import {
  POST_TASKS_TO_INCIDENT,
  POST_TASKS_TO_INCIDENT_START,
  POST_TASKS_TO_INCIDENT_SUCCESS,
  POST_TASKS_TO_INCIDENT_FAIL,
} from 'actions/incidentTaskLists';

export const defaultState = {
  loading: false,
  data: [],
  tasksAdded: [],
};

export default function incidentTaskLists(state = defaultState, action) {
  switch (action.type) {
    case POST_TASKS_TO_INCIDENT:
    case POST_TASKS_TO_INCIDENT_START:
      return {
        ...state,
        loading: true,
        error: {
          isError: false,
          errorCode: null,
        },
      };
    case POST_TASKS_TO_INCIDENT_SUCCESS:
      return {
        ...state,
        loading: false,
        tasksAdded: Object.values(action.payload).map(task => task.name),
      };
    case POST_TASKS_TO_INCIDENT_FAIL:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
}
